import { actions } from "../../utils/constants/main";

export const callSnackBar = (message, variant) => {
  return { type: actions.CALL_SNACKBAR_DATA, message, variant };
};
